import { createClient } from '@supabase/supabase-js';
import type { SupabaseClient } from '@supabase/supabase-js';
import { getSupabaseConfig } from './config';
import { deviceStorage } from './storage';

let client: SupabaseClient | null = null;
let clientUrl = '';

/**
 * Lazily built so `configureSupabase()` can run after module load, and rebuilt
 * if the URL ever changes. Returns null when no backend is configured, which is
 * a supported mode: the app then runs fully offline against device storage.
 */
export function getSupabase(): SupabaseClient | null {
  const config = getSupabaseConfig();
  if (!config) return null;
  if (client && clientUrl === config.url) return client;

  client = createClient(config.url, config.publishableKey, {
    auth: {
      // The session must survive an app restart, or a counter tablet would ask
      // staff to log in every morning.
      storage: deviceStorage,
      persistSession: true,
      autoRefreshToken: true,
      // React Native has no URL bar to read a callback out of.
      detectSessionInUrl: false,
    },
  });
  clientUrl = config.url;
  return client;
}

export function resetSupabase(): void {
  client = null;
  clientUrl = '';
}
